import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import { Button } from './ui/button';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        setIsMobileMenuOpen(false);
      }
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center space-x-3">
            <div className="text-2xl font-bold text-teal-700">Dr. VPB Koyyala</div>
          </Link>

          <div className="hidden md:flex items-center space-x-6">
            <Link to="/about" className="text-gray-700 hover:text-teal-700 transition-colors font-medium text-sm">
              About
            </Link>
            <Link to="/expertise" className="text-gray-700 hover:text-teal-700 transition-colors font-medium text-sm">
              Expertise
            </Link>
            <Link to="/achievements" className="text-gray-700 hover:text-teal-700 transition-colors font-medium text-sm">
              Achievements
            </Link>
            <Link to="/media" className="text-gray-700 hover:text-teal-700 transition-colors font-medium text-sm">
              Media
            </Link>
            <Link to="/gallery" className="text-gray-700 hover:text-teal-700 transition-colors font-medium text-sm">
              Gallery
            </Link>
            <Link to="/blog" className="text-gray-700 hover:text-teal-700 transition-colors font-medium text-sm">
              Blog
            </Link>
            <Link to="/contact">
              <Button className="bg-teal-700 hover:bg-teal-800 text-white">
                Contact
              </Button>
            </Link>
          </div>

          <button
            className="md:hidden text-gray-700"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t">
          <div className="px-4 py-6 space-y-4">
            <Link to="/about" className="block w-full text-left text-gray-700 hover:text-teal-700 transition-colors font-medium py-2" onClick={() => setIsMobileMenuOpen(false)}>About</Link>
            <Link to="/expertise" className="block w-full text-left text-gray-700 hover:text-teal-700 transition-colors font-medium py-2" onClick={() => setIsMobileMenuOpen(false)}>Expertise</Link>
            <Link to="/achievements" className="block w-full text-left text-gray-700 hover:text-teal-700 transition-colors font-medium py-2" onClick={() => setIsMobileMenuOpen(false)}>Achievements</Link>
            <Link to="/media" className="block w-full text-left text-gray-700 hover:text-teal-700 transition-colors font-medium py-2" onClick={() => setIsMobileMenuOpen(false)}>Media & Press</Link>
            <Link to="/gallery" className="block w-full text-left text-gray-700 hover:text-teal-700 transition-colors font-medium py-2" onClick={() => setIsMobileMenuOpen(false)}>Gallery</Link>
            <Link to="/blog" className="block w-full text-left text-gray-700 hover:text-teal-700 transition-colors font-medium py-2" onClick={() => setIsMobileMenuOpen(false)}>Blog</Link>
            <Link to="/contact" onClick={() => setIsMobileMenuOpen(false)}>
              <Button className="w-full bg-teal-700 hover:bg-teal-800 text-white">Contact</Button>
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navigation;